"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isIOS = exports.isAndroidFirefox = exports.isWindowsPhoneBrowser = exports.isAndroidBrowser = void 0;
function isAndroidBrowser() {
    var windows = new RegExp("windows", "i");
    var firefox = new RegExp("firefox", "i");
    var android = new RegExp("android", "i");
    var ua = navigator.userAgent;
    return !windows.test(ua) && !firefox.test(ua) && android.test(ua);
}
exports.isAndroidBrowser = isAndroidBrowser;
function isWindowsPhoneBrowser() {
    var windows = new RegExp("windows", "i");
    var phone = new RegExp("phone", "i");
    var ua = navigator.userAgent;
    return windows.test(ua) && phone.test(ua);
}
exports.isWindowsPhoneBrowser = isWindowsPhoneBrowser;
function isAndroidFirefox() {
    var windows = new RegExp("windows", "i");
    var firefox = new RegExp("firefox", "i");
    var android = new RegExp("android", "i");
    var ua = navigator.userAgent;
    return !windows.test(ua) && firefox.test(ua) && android.test(ua);
}
exports.isAndroidFirefox = isAndroidFirefox;
function isIOS() {
    var windows = new RegExp("windows", "i");
    var ios = new RegExp("(ipod|iphone|ipad)", "i");
    var ua = navigator.userAgent;
    return !windows.test(ua) && ios.test(ua);
}
exports.isIOS = isIOS;
